import { render, staticRenderFns } from "./applicant_table.vue?vue&type=template&id=47f09f54&scoped=true"
import script from "./applicant_table.vue?vue&type=script&lang=ts"
export * from "./applicant_table.vue?vue&type=script&lang=ts"
import style0 from "./applicant_table.vue?vue&type=style&index=0&id=47f09f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f09f54",
  null
  
)

export default component.exports